import { APP_BASE_HREF, Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from '@app/core';
import { BreadCrumbsComponent, ConfirmationModule } from '@app/library';
import { SharedModule } from '@app/shared';
import { NguModalModule } from '../app/extras/ngu-modal';
import { AppComponent } from './app.component';
import { AppRoutedComponents, AppRoutingModule } from './app.routing';
import { NavigationComponent } from './navigation/navigation.component';
import { RoleFilterPipe } from './navigation/role.pipe';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { environment } from '@env/environment.prod';
import { UpdatePasswordComponent } from './update-password/update-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { Angular2CsvModule } from 'angular2-csv';
import { AlertModule } from 'alert-notification';

// import { NguModalModule } from './extras/ngu-modal';

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    AppRoutedComponents,
    BreadCrumbsComponent,
    RoleFilterPipe,
    HomeComponent, 
    LoginComponent, 
    ResetPasswordComponent, 
    UpdatePasswordComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    AppRoutingModule,
    NguModalModule,
    ConfirmationModule.forRoot(),
    RecaptchaV3Module,
    Angular2CsvModule,
    AlertModule
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    Location,
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }